import { Box, useMediaQuery, useTheme } from '@mui/material';
import { MatchListType, SocketClientMessage, TournamentsListType } from '@okletsplay/core';
import { useSocketSubscriber } from 'app/hooks/socket';
import { useFetchData } from 'app/hooks/store';
import { gamesSelector } from 'modules/games/store/games/selectors';
import { MatchesCarousel } from 'modules/matches/components/MatchesCarousel';
import { getMatchesList } from 'modules/matches/store/matches/repository';
import { matchesSelector } from 'modules/matches/store/matches/selectors';
import { TournamentsCarousel } from 'modules/tournaments/components/TournamentsCarousel';
import { getTournamentsList } from 'modules/tournaments/store/tournaments/repository';
import { tournamentsSelector } from 'modules/tournaments/store/tournaments/selectors';
import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Loader } from 'shared/components/Loader';
import { MobileGameCarousel } from 'modules/games/components/MobileGameCarousel';
import { Controls } from '../components/Controls';
import { useStyles } from './HomePage.styles';

const CarouselContainer: FC<{ isMobile: boolean }> = ({ isMobile, children }) => {
  if (!isMobile) {
    return <>{children}</>;
  }

  return <Box ml={2}>{children}</Box>;
};

const HomePage: FC = () => {
  const theme = useTheme();
  const { classes } = useStyles();
  const games = useSelector(gamesSelector.enabled);
  const matches = useSelector(matchesSelector.featured);
  const tournaments = useSelector(tournamentsSelector.featured);
  const isMobileView = useMediaQuery(theme.breakpoints.down('lg'));

  const actions = useMemo(
    () => [
      getTournamentsList({ type: TournamentsListType.Featured }),
      getMatchesList({ type: MatchListType.Featured }),
    ],
    []
  );
  const { loading, fetch } = useFetchData(actions);

  useSocketSubscriber([
    {
      action: SocketClientMessage.Tournament,
      handler: () => fetch(false),
    },
  ]);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <CarouselContainer isMobile={isMobileView}>
        <MobileGameCarousel games={games} />
      </CarouselContainer>
      <CarouselContainer isMobile={isMobileView}>
        <TournamentsCarousel tournaments={tournaments} />
      </CarouselContainer>
      <CarouselContainer isMobile={isMobileView}>
        <MatchesCarousel matches={matches} />
      </CarouselContainer>

      <Box className={classes.controls}>
        <Controls />
      </Box>
    </>
  );
};

export default HomePage;
